import React from 'react';
import { Box, Container, Typography, Button, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import GuestIcon from '@mui/icons-material/PersonOutline';

const AccessSelection: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md" sx={{ py: 8 }}>
            <Typography variant="h3" align="center" gutterBottom sx={{ fontWeight: 700 }}>
                Choose Your Access
            </Typography>
            <Typography variant="h6" align="center" color="text.secondary" sx={{ mb: 6 }}>
                Select how you'd like to use the P2P Exchange platform
            </Typography>

            <Box sx={{ display: 'flex', gap: 4, justifyContent: 'center', flexWrap: 'wrap' }}>
                <Card sx={{ width: 300, cursor: 'pointer' }} onClick={() => navigate('/guest')}>
                    <CardContent sx={{ textAlign: 'center', p: 4 }}>
                        <GuestIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
                        <Typography variant="h5" gutterBottom>
                            Guest Access
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Use the exchange calculator with basic features. No account required.
                        </Typography>
                        <Button variant="contained" fullWidth>
                            Continue as Guest
                        </Button>
                    </CardContent>
                </Card>

                <Card sx={{ width: 300, cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
                    <CardContent sx={{ textAlign: 'center', p: 4 }}>
                        <PersonIcon sx={{ fontSize: 60, color: 'secondary.main', mb: 2 }} />
                        <Typography variant="h5" gutterBottom>
                            User Account
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Full access with saved preferences, history, and advanced features.
                        </Typography>
                        <Button variant="outlined" fullWidth>
                            Sign Up / Login
                        </Button>
                    </CardContent>
                </Card>
            </Box>
        </Container>
    );
};

export default AccessSelection; 